module.exports = __webpack_public_path__ + "static/media/block-2-item-1.585ae007.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/block-2-item-1.jpg
// module id = 1251
// module chunks = 270